import { render, staticRenderFns } from "./PasswordChangeForm.vue?vue&type=template&id=6c022e6e&scoped=true&"
import script from "./PasswordChangeForm.vue?vue&type=script&lang=js&"
export * from "./PasswordChangeForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordChangeForm.vue?vue&type=style&index=0&id=6c022e6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c022e6e",
  null
  
)

export default component.exports